const INITIAL_STATE = {
  motivoInativoList: [],
  motivoInativo: null
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'MOTIVOINATIVOLIST_FETCH':
        return { ...state, motivomotivoInativoList: action.payload }
      case 'MOTIVOINATIVO_SET':
        return { ...state, motivomotivoInativo: action.payload }
      default:
        return state
    }
  }